import styled from "styled-components";
import PropTypes from "prop-types";

import { ProfileMenuDesktop } from "components/ProfileMenuDesktop";
import { ProfileMenuMobile } from "components/ProfileMenuMobile";

import { openMobileMenuStyles } from "components/ProfileMenuMobile/styles";
import { Link } from "core/SiteHeader/styles";

import { easingSeconds } from "core/animation";
import Flexbox from "core/Flexbox";
import { ButtonStyle, GrayButtonStyle } from "core/Button";
import breakpoints from "core/breakpoints";
import colors from "core/colors";

// for LoggedOutLinks
export const LoggedOutFlexbox = styled(Flexbox)``;

export const Join = styled(Link)`
    margin-left: 1rem;
    ${ButtonStyle};
    ${GrayButtonStyle};
    color: ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 ? colors.ink : `${colors.snow}!important`};
    text-decoration: none !important;
    /* this doesnt work without !important */
    font-size: 0.75rem;
    line-height: 0.75rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    @media (max-width: ${breakpoints.beforeTablet}rem) {
        display: none;
    }

    ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 &&
        `
        &&,
        &.scrolledUp {
            background-color: ${colors.mist};
            color: ${colors.ink};

            &:hover {
                background-color: ${colors.pebble};
                color: ${colors.mist};
            }
        }
        
        /* when SiteHeader has scrolledDown class: */
        .scrolledDown & {
            background-color: ${colors.charcoalTwo};
            color: ${colors.snow};

            &:hover {
                background-color: ${colors.blackDuplicate};
                color: ${colors.coin};
            }
        }
    `}
`;

export const Login = styled(Link)`
    ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 &&
        `
    /* when SiteHeader has scrolledDown class: */
    .scrolledDown & {
        color: ${colors.storm};

        &:hover {
            color: ${colors.black};
        }
    }
`}
`;

// for LoggedInLinks
export const AvatarWrapper = styled.div`
    cursor: pointer;
    width: 1.5rem;
    height: 1.5rem;
`;

const UserAvatar = styled.img`
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    opacity: ${({ active }) => (active ? "0.6" : "1")};
    vertical-align: middle;
    transition: all ${easingSeconds};

    &:hover {
        opacity: 0.6;
    }
`;

UserAvatar.propTypes = {
    active: PropTypes.bool
};

export { UserAvatar };

// for ProfileMenu
const Wrapper = styled.div`
    ${ProfileMenuDesktop} {
        /* toggle menu */
        display: ${({ open }) => (open ? "block" : "none")};

        /* hide menu on smaller screens */
        @media (max-width: ${breakpoints.beforeTablet}rem) {
            display: none;
        }
    }

    ${ProfileMenuMobile} {
        display: none;

        @media (max-width: ${breakpoints.beforeTablet}rem) {
            /* toggle menu  */
            ${({ open }) => open && openMobileMenuStyles}
        }
    }

    /* Tablet +: */
    @media (min-width: ${breakpoints.md}rem) {
        position: relative;
        height: 28px;
        /* to prevent content bouncing when navigating from page to page */
    }
`;

Wrapper.propTypes = {
    open: PropTypes.bool
};

export { Wrapper };
